const OUTGOING_WEBHOOK_EVENTS = Object.freeze({
    DONATE: 'donate', //legacy event, replaced with 'donationCreated'
    DONATION_CREATED: 'donationCreated',
    DONATION_UPDATED: 'donationUpdated',
    DONATION_DELETED: 'donationDeleted',
    TEAM_CREATED: 'teamCreated',
});

const OUTGOING_WEBHOOK_STATUS = Object.freeze({
    FAILING: 'failing',
    UNKNOWN: 'unknown',
    WORKING: 'working',
});

module.exports = {
    OUTGOING_WEBHOOK_STATUS,
    OUTGOING_WEBHOOK_EVENTS,
};
